
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return Promise.all(/*  | __federation_expose_app */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("204"), __webpack_require__.e("194")]).then(() => (() => (__webpack_require__(2472))));
},
"./report-config-wrapper": () => {
return __webpack_require__.e(/*  | __federation_expose_report_config_wrapper */ "265").then(() => (() => (__webpack_require__(7578))));
},
"./report-designer": () => {
return Promise.all(/*  | __federation_expose_report_designer */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("204"), __webpack_require__.e("893"), __webpack_require__.e("187")]).then(() => (() => (__webpack_require__(1921))));
},
"./report-viewer": () => {
return Promise.all(/*  | __federation_expose_report_viewer */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("893"), __webpack_require__.e("312")]).then(() => (() => (__webpack_require__(2687))));
},
"./report-table": () => {
return Promise.all(/*  | __federation_expose_report_table */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("398"), __webpack_require__.e("314"), __webpack_require__.e("658")]).then(() => (() => (__webpack_require__(4448))));
},
"./report-template-library": () => {
return Promise.all(/*  | __federation_expose_report_template_library */ [__webpack_require__.e("225"), __webpack_require__.e("563")]).then(() => (() => (__webpack_require__(5465))));
},
"./use-report-instance": () => {
return __webpack_require__.e(/*  | __federation_expose_use_report_instance */ "438").then(() => (() => (__webpack_require__(3825))));
},
"./use-export-report": () => {
return __webpack_require__.e(/*  | __federation_expose_use_export_report */ "908").then(() => (() => (__webpack_require__(7376))));
},
"./store": () => {
return __webpack_require__.e(/*  | __federation_expose_store */ "982").then(() => (() => (__webpack_require__(184))));
},
"./quality-check-ai-report-generation": () => {
return Promise.all(/*  | __federation_expose_quality_check_ai_report_generation */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("885")]).then(() => (() => (__webpack_require__(3306))));
},
"./asrs-compliance-ai-report-generation": () => {
return Promise.all(/*  | __federation_expose_asrs_compliance_ai_report_generation */ [__webpack_require__.e("225"), __webpack_require__.e("241"), __webpack_require__.e("204"), __webpack_require__.e("702")]).then(() => (() => (__webpack_require__(5779))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };